import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const Error = createIcon({
  displayName: 'Error',
  viewBox: '0 0 68 68',
  path: [
    <svg fill="none" height="68" key="error">
      <path
        d="M34 0.666016C15.6 0.666016 0.666656 15.5993 0.666656 33.9994C0.666656 52.3994 15.6 67.3327 34 67.3327C52.4 67.3327 67.3333 52.3994 67.3333 33.9994C67.3333 15.5993 52.4 0.666016 34 0.666016ZM37.3333 50.666H30.6667V43.9994H37.3333V50.666ZM37.3333 37.3327H30.6667V17.3327H37.3333V37.3327Z"
        fill="currentColor"
      />
    </svg>,
  ],
})
